var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import { DatagridConfigurable, List, TextField, TextInput, useDelete, WrapperField, FunctionField, useRefresh, useNotify, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Button, Tooltip, Typography } from "@mui/material";
import { Dialog, IconButton } from "@sequentech/ui-essentials";
import { ActionsColumn } from "../../components/ActionButons";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { WizardSteps } from "./TallySheetWizard";
import { useMutation } from "@apollo/client";
import { PUBLISH_TALLY_SHEET } from "@/queries/PublishTallySheet";
import { ContestItem } from "@/components/ContestItem";
import { AreaItem } from "@/components/AreaItem";
import { Add } from "@mui/icons-material";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
import { AuthContext } from "@/providers/AuthContextProvider";
var OMIT_FIELDS = ["id", "ballot_eml"];
var Filters = [
    _jsx(TextInput, { label: "Area", source: "area_id" }, 0),
    _jsx(TextInput, { label: "Contest", source: "contest" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Published", source: "published_at" }, 3),
];
export var ListTallySheet = function (props) {
    var contest = props.contest, doAction = props.doAction, reload = props.reload;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var notify = useNotify();
    var deleteOne = useDelete()[0];
    var _a = React.useState(false), openDeleteModal = _a[0], setOpenDeleteModal = _a[1];
    var _b = React.useState(false), openUnpublishDialog = _b[0], setOpenUnpublishDialog = _b[1];
    var _c = React.useState(false), openPublishDialog = _c[0], setOpenPublishDialog = _c[1];
    var _d = React.useState(), deleteId = _d[0], setDeleteId = _d[1];
    var publishTallySheet = useMutation(PUBLISH_TALLY_SHEET)[0];
    var _e = React.useState(false), publish = _e[0], setPublish = _e[1];
    var authContext = useContext(AuthContext);
    var canCreate = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_CREATE);
    var canView = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_VIEW);
    var canPublish = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_PUBLISH);
    var canDelete = authContext.isAuthorized(true, tenantId, IPermissions.TALLY_SHEET_DELETE);
    useEffect(function () {
        localStorage.removeItem("tallySheetData");
    }, []);
    useEffect(function () {
        if (reload) {
            refresh();
        }
    }, [reload, refresh]);
    var createAction = function () {
        localStorage.removeItem("tallySheetData");
        doAction(WizardSteps.Start);
    };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("tallysheet.empty.header") })), canCreate && (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ onClick: createAction }, { children: [_jsx(IconButton, { icon: faPlus, fontSize: "24px" }), t("tallysheet.empty.action")] })), _jsx(Typography, __assign({ variant: "body1", paragraph: true }, { children: t("common.resources.noResult.askCreate") }))] }))] })); };
    if (!canView) {
        return _jsx(Empty, {});
    }
    var editAction = function (id) {
        doAction(WizardSteps.Edit, id);
    };
    var viewAction = function (id) {
        doAction(WizardSteps.View, id);
    };
    var publishAction = function (id) {
        setDeleteId(id);
        setOpenPublishDialog(true);
    };
    var unpublishAction = function (id) {
        setDeleteId(id);
        setOpenUnpublishDialog(true);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () {
        deleteOne("sequent_backend_tally_sheet", { id: deleteId }, {
            onSuccess: function () {
                refresh();
            },
        });
        setDeleteId(undefined);
    };
    var confirmPublishAction = function (isPublished) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, publishTallySheet({
                        variables: {
                            electionEventId: contest.election_event_id,
                            tallySheetId: deleteId,
                            publish: isPublished,
                        },
                    })];
                case 1:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    if (data && !((_b = data === null || data === void 0 ? void 0 : data.publish_tally_sheet) === null || _b === void 0 ? void 0 : _b.tally_sheet_id)) {
                        console.log("(unpublished) tally sheet not found, probably it's already published");
                    }
                    if (errors) {
                        // add error notification
                        notify(t("tallysheet.message.publishError"), { type: "error" });
                    }
                    else {
                        notify(t("tallysheet.message.publishSuccess"), { type: "success" });
                    }
                    setDeleteId(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var actions = function (record) { return [
        { icon: _jsx(EditIcon, {}), action: editAction, showAction: function () { return canCreate; } },
        { icon: _jsx(VisibilityIcon, {}), action: viewAction, showAction: function () { return canView; } },
        {
            icon: (_jsx(Tooltip, __assign({ title: t("tallysheet.common.publish") }, { children: _jsx(PublishedWithChangesIcon, {}) }))),
            action: publishAction,
            showAction: function () { return canPublish && record.published_at === null; },
        },
        {
            icon: (_jsx(Tooltip, __assign({ title: t("tallysheet.common.unpublish") }, { children: _jsx(UnpublishedIcon, {}) }))),
            action: unpublishAction,
            showAction: function () { return canPublish && record.published_at !== null; },
        },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction, showAction: function () { return canDelete; } },
    ]; };
    return (_jsxs(_Fragment, { children: [_jsx(List, __assign({ queryOptions: {
                    refetchInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
                }, resource: "sequent_backend_tally_sheet", actions: _jsx(ListActions, { withImport: false, withExport: false, extraActions: [
                        _jsxs(Button, __assign({ onClick: createAction }, { children: [_jsx(Add, {}), t("tallysheet.empty.add")] }), 0),
                    ] }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: contest.tenant_id || undefined,
                    election_event_id: contest.election_event_id || undefined,
                    contest_id: contest.id || undefined,
                    election_id: contest.election_id || undefined,
                    deleted_at: {
                        format: "hasura-raw-query",
                        value: { _is_null: true },
                    },
                }, filters: Filters, empty: _jsx(Empty, {}) }, { children: _jsxs(DatagridConfigurable, __assign({ omit: OMIT_FIELDS }, { children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "channel" }), _jsx(FunctionField, { label: t("tallysheet.table.contest"), render: function (record) { return _jsx(ContestItem, { record: contest.id }); } }), _jsx(FunctionField, { label: t("tallysheet.table.area"), render: function (record) { return (_jsx(AreaItem, { record: record.area_id })); } }), _jsx(FunctionField, { label: t("tallysheet.table.published"), render: function (record) {
                                return record.published_at ? _jsx(CheckCircleOutlineIcon, { color: "success" }) : null;
                            } }), _jsx(WrapperField, __assign({ source: "actions", label: "Actions" }, { children: _jsx(FunctionField, { label: t("tallysheet.table.area"), render: function (record) { return (_jsx(ActionsColumn, { actions: actions(record) })); } }) }))] })) })), _jsx(Dialog, __assign({ variant: "warning", open: openDeleteModal, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                } }, { children: t("common.message.delete") })), _jsx(Dialog, __assign({ variant: "warning", open: openUnpublishDialog, ok: t("tallysheet.common.unpublish"), cancel: t("common.label.cancel"), title: t("tallysheet.common.unpublish"), handleClose: function (result) {
                    if (result) {
                        confirmPublishAction(false);
                    }
                    setOpenUnpublishDialog(false);
                } }, { children: t("tallysheet.common.warningUnPublish") })), _jsx(Dialog, __assign({ variant: "info", open: openPublishDialog, ok: t("tallysheet.common.publish"), cancel: t("common.label.cancel"), title: t("tallysheet.common.publish"), handleClose: function (result) {
                    if (result) {
                        confirmPublishAction(true);
                    }
                    setOpenPublishDialog(false);
                } }, { children: t("tallysheet.common.warningPublish") }))] }));
};
